import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import heroImage from '@/assets/new-hero-grass-depot.jpg';

const HeroSection = () => {
  const { language, t } = useLanguage();

  return (
    <section className="relative h-[70vh] min-h-[500px] flex items-center justify-center overflow-hidden">
      {/* Background Image - Optimized for LCP */}
      <img 
        src={heroImage}
        alt="The Grass Depot - Premium Landscaping Materials Texas"
        className="absolute inset-0 w-full h-full object-cover"
        width="1335"
        height="658"
        fetchPriority="high"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-transparent"></div>
      
      {/* Content */}
      <div className="relative container mx-auto px-4 text-center lg:text-left z-10">
        <div className="max-w-2xl">
          <h1 className="text-4xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            {t('hero.title')}
          </h1>
          <p className="text-xl lg:text-2xl text-white/90 mb-8 leading-relaxed">
            {t('hero.subtitle')}
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
            <Link to={`/${language}/quote`}>
              <Button variant="hero" size="lg" className="w-full sm:w-auto text-lg px-8 py-4">
                {t('hero.cta.quote')}
              </Button>
            </Link>
            
            <a href="tel:9363200763">
              <Button variant="outline" size="lg" className="w-full sm:w-auto text-lg px-8 py-4 border-white text-primary hover:bg-white hover:text-foreground">
                {t('hero.cta.call')}
              </Button>
            </a>
          </div>
          
          {/* Trust Indicators */}
          <div className="mt-12 flex flex-wrap gap-6 justify-center lg:justify-start text-white/80">
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-accent rounded-full"></div>
              <span className="text-sm">Montgomery County Delivery</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-accent rounded-full"></div>
              <span className="text-sm">Premium Quality</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-accent rounded-full"></div>
              <span className="text-sm">Local Family Business</span>
            </div>
          </div>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
        <div className="w-6 h-10 border-2 border-white rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white rounded-full mt-2"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;